module.exports = __webpack_public_path__ + "static/poster-01-51874207f7ef45bd3b7992c155c70838.jpg";